import { useContext } from 'react';
import InnerDateField from '../DateField/InnerDateField';
import { isLater } from '@/lib/utils/dateUtils';
import convertToTimestamp from './utils/convertToTimestamp';
import useSavePortfolioItemDate from './utils/useSavePortfolioItemDate';
import PortfolioItemContext from '../../../../PortfolioItemContext';
import moment from 'moment';

const PlannedStartDate = () => {
  const { portfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  const savePortfolioItemDate = useSavePortfolioItemDate(
    `${portfolioItemApiEndpoint}/dates/planned-start-date`,
  );

  return (
    <InnerDateField
      initialValue={convertToTimestamp(portfolioItem.plannedStartDate)}
      onSave={savePortfolioItemDate}
      shouldDisableDate={
        portfolioItem.plannedEndDate === null
          ? undefined
          : date => isLater(date, moment(portfolioItem.plannedEndDate))
      }
      clearable
    />
  );
};

export default PlannedStartDate;
